import { useDispatch, useSelector } from 'react-redux';
import { selectTermsDurationInDays, selectTermsDurations } from '../../../../../../../selectors/termsDurations';
import { getActiveDurationIdx } from '../utils';
import { useCallback } from 'react';
import { setTermsDuration } from '../../../../../../../actions/termsDurations';
import { useDurationsAnalytics } from './useDurationsAnalytics';
import { selectIsServicesEnabled } from '../../../../../../../reducers/v2/promotion/selectors';

export const useDurations = () => {
  const dispatch = useDispatch();

  const { trackShowDurations, trackClickDuration } = useDurationsAnalytics();

  const stateDurations = useSelector(selectTermsDurations);
  const selectedDurationInDays = useSelector(selectTermsDurationInDays);
  const activeDurationIndex = getActiveDurationIdx(stateDurations, selectedDurationInDays);
  const isPromotionEnabled = useSelector(selectIsServicesEnabled);

  const setDuration = useCallback(
    ({ duration, discount }: { duration: number; discount: number }) => {
      dispatch(setTermsDuration(duration));

      trackClickDuration({ duration, discount });
    },
    [dispatch, trackClickDuration],
  );

  const durations = stateDurations.map(({ durationInDays, discountPercent, selected }) => ({
    durationInDays,
    discountPercent,
    selected,
    disabled: !isPromotionEnabled,
  }));

  return {
    durations,
    selectedDurationInDays,
    activeDurationIndex,
    onChange: setDuration,
    onShow: trackShowDurations,
  };
};
